import React from 'react';
import { Link, useParams } from 'react-router-dom';
import catalog from '../data/labs.json';
import { LabDetailView } from '../components/LabViews';
export const RouterAnchor = ({ href, ...props }) => <Link to={href} {...props} />;
export default function LabDetailPage() {
  const { slug } = useParams();
  const index = catalog.labs.findIndex(lab => lab.slug === slug);
  if (index < 0) return <main dir="rtl" className="p-8 text-center"><h1>نام آزمایشگاه پیدا نشد</h1><Link to="/labs-page">بازگشت به فهرست آزمایشگاه‌ها</Link></main>;
  const related = [1, 2, 3].map(offset => catalog.labs[(index + offset) % catalog.labs.length]).filter(lab => lab.slug !== slug);
  return <LabDetailView lab={catalog.labs[index]} related={related} LinkComponent={RouterAnchor} />;
}
